import { gql } from '@apollo/client';

export default gql`
  fragment Lesson on Lesson {
    _id
    name
    createdAt
    course
    group
    students {
      student
    }
  }
`;
